import type { SourcingEventV2Dto } from "../../../../autogen/bff-api";
import { hasTenderStageQualification } from "../../../sourcing-events/buyer/wizard/utils/procedure";
import { RequestQualificationTab } from "./RequestQualificationTab";
import { TenderQualificationTab } from "./tender/TenderQualificationTab";

interface Props {
  event: SourcingEventV2Dto;
}

// Where the qualification happens follows the procedure: two-stage procedures qualify the
// forespørsler om å delta, single-stage ones qualify the delivered tenders.
export const QualificationTab = ({ event }: Props) => {
  const procedureType =
    event.eventContext.type === "Public" ? event.eventContext.procedureType : undefined;
  return hasTenderStageQualification(procedureType) ? (
    <TenderQualificationTab event={event} />
  ) : (
    <RequestQualificationTab event={event} />
  );
};
